import Axios from "axios";
var BusinessGoodsPriceService = (function () {
    function BusinessGoodsPriceService() {
    }
    BusinessGoodsPriceService.prototype.getList = function (params) {
        return Axios.get("supplierclientapi/businessgoodsprice/list", { params: params });
    };
    BusinessGoodsPriceService.prototype.getCategory = function (params) {
        return Axios.get("supplierclientapi/suppliergoodstype/type_list", { params: params });
    };
    BusinessGoodsPriceService.prototype.getGoodList = function (params) {
        return Axios.get("supplierclientapi/businessgoodsprice/detail_list", { params: params });
    };
    BusinessGoodsPriceService.prototype.audit = function (params) {
        return Axios.get("supplierclientapi/businessgoodsprice/audit", { params: params });
    };
    BusinessGoodsPriceService.prototype.discard = function (params) {
        return Axios.get("supplierclientapi/businessgoodsprice/cancel", { params: params });
    };
    BusinessGoodsPriceService.prototype.stop = function (params) {
        return Axios.get("supplierclientapi/businessgoodsprice/stop", { params: params });
    };
    BusinessGoodsPriceService.prototype.start = function (params) {
        return Axios.get("supplierclientapi/businessgoodsprice/start", { params: params });
    };
    BusinessGoodsPriceService.prototype.getBusiness = function (params) {
        return Axios.get("supplierclientapi/businessgoodsprice/get_business", { params: params });
    };
    BusinessGoodsPriceService.prototype.setBusiness = function (data) {
        return Axios.post("supplierclientapi/businessgoodsprice/set_business", data);
    };
    BusinessGoodsPriceService.prototype.delayEeTime = function (data) {
        return Axios.post("supplierclientapi/businessgoodsprice/delay", data);
    };
    BusinessGoodsPriceService.prototype.getClientsByGroupTree = function (params) {
        return Axios.get("supplierclientapi/customer/group_childs", { params: params });
    };
    BusinessGoodsPriceService.prototype.getAddCategory = function (params) {
        return Axios.get("supplierclientapi/suppliergoodstype/category_tree", { params: params });
    };
    BusinessGoodsPriceService.prototype.getAddGoodslist = function (params) {
        return Axios.get("supplierclientapi/common/goods_format_list", { params: params });
    };
    BusinessGoodsPriceService.prototype.addSave = function (data) {
        return Axios.post("supplierclientapi/businessgoodsprice/create", data);
    };
    BusinessGoodsPriceService.prototype.editSave = function (data) {
        return Axios.post("supplierclientapi/businessgoodsprice/update", data);
    };
    BusinessGoodsPriceService.prototype.getDetail = function (params) {
        return Axios.get("supplierclientapi/businessgoodsprice/detail", { params: params });
    };
    BusinessGoodsPriceService.prototype.getGoodslist = function (params) {
        return Axios.get("supplierclientapi/common/goods_list", { params: params });
    };
    BusinessGoodsPriceService.prototype.getCooperationBusinessList = function (params) {
        return Axios.get("supplierclientapi/document/cooperation_business_list", { params: params });
    };
    BusinessGoodsPriceService.prototype.getBusinessGoodsTypeList = function (params) {
        return Axios.get("supplierclientapi/document/business_goods_type_list", { params: params });
    };
    BusinessGoodsPriceService.prototype.getBusinessGoodsList = function (params) {
        return Axios.get("supplierclientapi/document/business_goods_list", { params: params });
    };
    BusinessGoodsPriceService.prototype.getOrderGoodsList = function (params) {
        return Axios.get("supplierclientapi/purchaseorder/get_order_goods_list", { params: params });
    };
    BusinessGoodsPriceService.prototype.getPriceBase = function (data) {
        return Axios.post("supplierclientapi/businessgoodsprice/get_price_base", data);
    };
    BusinessGoodsPriceService.createInstance = function () {
        BusinessGoodsPriceService.getInstance();
    };
    BusinessGoodsPriceService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return BusinessGoodsPriceService;
}());
export default BusinessGoodsPriceService;
